import React from 'react';
import PropTypes from 'prop-types';
import { getUrl } from 'aws-amplify/storage';
import "./SensorPropertyInfoDialog.css";

const propTypes = {
  onClose: PropTypes.func,
};
const defaultProps = {
  onClose: () => { }
};

const SensorPropertyInfoDialog = (props) => {
  /*** States and Variables ***/
  const backgroundRef = React.useRef(null);
  const [srcs, setSrcs] = React.useState([]);
  /*** Processing ***/
  React.useEffect(() => {
    const getImageSources = async () => {
      const results = await Promise.all([1, 2, 3, 4, 5].map(async item => (await getUrl({ key: `image/para_${item}.png` })).url.toString()))
      setSrcs(results)
    }
    getImageSources();
  }, [])
  /*** Sub Components ***/
  /*** Event Handlers ***/
  const onClickBackground = (e) => {
    if (e.target === backgroundRef.current) {
      props.onClose();
    }
  }
  /*** Main Render ***/
  return <div
    className='sensor_property_info_dialog_container'
    onClick={onClickBackground}
    ref={backgroundRef}>
    <div className='sensor_property_info_dialog'>
      {srcs.map(s => {
        if (!s) return null;
        return <img
          key={s}
          className='sensor_property_info_dialog_image'
          src={s}
          alt=''
        />
      })}
    </div>
  </div>;
}
SensorPropertyInfoDialog.propTypes = propTypes;
SensorPropertyInfoDialog.defaultProps = defaultProps;
export default SensorPropertyInfoDialog;